import React from "react";
import PropTypes from 'prop-types';

var Bin = function Bin(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 19 : _ref$height,
      className = _ref.className,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#444749' : _ref$fill;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: width,
    height: height,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 1.01913L12 0L4 0L3 1L0 1L0 2.48419L16 2.5V1L13 1.01913Z",
    fill: fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7H6.5L6.5 16H5L5 7Z",
    fill: fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7L11 7L11 16H9.5L9.5 7Z",
    fill: fill
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4L15 4L15 16.8571C15 18.0357 14.0308 19 12.8462 19H3.15385C1.96923 19 1 18.0357 1 16.8571L1 4ZM2.5 16.8571C2.5 17.2001 2.79042 17.5 3.15385 17.5H12.8462C13.2096 17.5 13.5 17.2001 13.5 16.8571L13.5 5.5L2.5 5.5L2.5 16.8571Z",
    fill: fill
  }));
};

Bin.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  fill: PropTypes.string
};
export default Bin;